const INITIAL_STATE = {
  data: {},
  errors: {},
}

const updateCard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_CARD':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'UPDATE_CARD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default updateCard;
